import GetMobileAppCallbackPage from './GetMobileAppCallagePage';

export default GetMobileAppCallbackPage;
